export default {
  en: {
    'components.forgot-password-form.instructions':
      'Enter the email address used during registration. Instructions to reset your password will be emailed to you.',

    'components.forgot-password-form.email.label': 'Email address',
    'components.forgot-password-form.email.placeholder': 'Enter email address',
    'components.forgot-password-form.email.required': 'Please enter an email address',
    'components.forgot-password-form.email.invalid': 'Please enter a valid email address',

    'components.forgot-password-form.action.submit': 'Reset password',
    'components.forgot-password-form.action.forgot-email': 'Forgot email?',

    'components.forgot-password-form.response.failure': 'Forgot password request failed.',
  },
};
